import { BlobClient } from '@azure/storage-blob';
import { Box, Flex, Image } from '@chakra-ui/react';
import { LoadError } from '@react-pdf-viewer/core';
import fileDeleteIcon from 'assets/image/delete-file.png';
import { PreviewFileState } from 'containers/Summary/FilePreviewDialog';
import { useCallback } from 'react';
import { downloadFileBlob } from 'utils/blob';
import '@react-pdf-viewer/core/lib/styles/index.css';

const renderError = (error: LoadError, fileData?: PreviewFileState) => {
  let message = '';
  switch (error.name) {
    case 'InvalidPDFException':
      message = 'The document is invalid or corrupted';
      break;
    case 'MissingPDFException':
      message = 'The file has been deleted';
      break;
    case 'ExtensionNotSupported':
      message = 'The file extension is not supported to be preview.';
      break;
    case 'UnexpectedResponseException':
      message = 'Unexpected server response';
      break;
    default:
      message = 'Cannot load the document';
      break;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const downloadFile = useCallback(async () => {
    if (fileData) {
      const { name = '', url = '' } = fileData;
      const container = new BlobClient(url);
      const downloadBlockBlobResponse = await container.download();
      const blobData = await downloadBlockBlobResponse.blobBody;
      if (blobData) {
        downloadFileBlob(blobData, name);
      }
    }
  }, [fileData]);

  return (
    <Flex align='center' justify='center' h='100%' textAlign='center' bg='red.50'>
      <Box>
        <Image w={32} m='auto' mb={4} src={fileDeleteIcon} />
        <Box color='gray.500' fontSize={26} fontWeight={600}>
          {message}
        </Box>
        {error.name === 'ExtensionNotSupported' && (
          <Box color='gray.500' fontSize={26} fontWeight={600}>
            Click{' '}
            <Box as='a' textDecoration='underline' cursor='pointer' onClick={downloadFile}>
              here
            </Box>{' '}
            to download file
          </Box>
        )}
      </Box>
    </Flex>
  );
};

export default renderError;
